export enum EventAttendeeTypeEnum {
  FIRST_NAME = 'first_name',
  LAST_NAME = 'last_name',
  EMAIL = 'email',
  PREFIX = 'prefix',
  GENDER = 'gender',
  BIRTHDAY = 'birthday',
  AGE = 'age',
  PHONE = 'phone',
  SHIPPING_ADDRESS = 'shipping_address',
  HOME_ADDRESS = 'home_address',
  WEBSITE = 'website',
  ZIP = 'zip',
}
